import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';

import Shareelement from './shareelement';
import ChapterNavi from './chapter_navi';

import playlist_songs from "./chapter3/songs";

import Timeline from './chapter3/chapter_three_timeline';

import Pause_menu from './pause_menu';

import ArtworkGenerator from './chapter3/artwork';
import Playlist from './chapter3/playlist';

import Iconset from './icons';

import '../styles/chapter_three.scss';
import '../styles/main-nav.scss';

class Chapter_three extends React.Component{
	constructor(props){
		super(props);

		this.state = {
			showPlaylistIntro : true,
			isPlaying : true,
			isWaiting : false,
			showSongIntro : true,
			showSongTeaser : false,
			showMobileTrigger : false,
			wasMobileTriggered : false,
			otherTrigger : false,
			currentSong : 0,
			songNaviOpen : false,
			currentInnerChapter : 0, // testcase
			currentVideoTimePercentage : 0,
			currentInnerChapterTime : 0,
			generatorIsActive : false
		}

		this.checkSongDates();
	}


	componentDidMount(){
		
	}

	checkSongDates(){
		let date = new Date();
		let day = date.getDate();
		let month = date.getMonth();
		let year = date.getYear();

		//testcase

		//day = 16;
		//month = 2;
		//year = 117;
		//console.log('testcase song release date: date set to:' , day,month,year);

		playlist_songs.forEach((song,index)=>{
			// 2018 natürlich komplett aktiv
			if(year >= 118){
				song.active = true;
			}else{
				// nach März 2017 komplett aktiv April ist nr. 3 
				//weil bei 0 angefangen wird zu zahlen
				if(month >= 3){
					song.active = true;
				}else{
					if(song.release <= day){
						song.active = true;
					}
				}
			}
		});
	}



	//_______

	changeSongToIndex(index){
		this.pause();
		this.setState({
			currentSong : index,
			songNaviOpen : false
		},()=>{
			this.play();
		});
	}

	setOtherTrigger(){
		this.setState({
			otherTrigger : false,
		})
	}

	toggleNavi(bool){
		this.setState({
			songNaviOpen : bool
		},()=>{
			if(this.state.songNaviOpen){
				this.pause();
			}else{
				this.play();
			}
		})
	}

	generatorIsActive(){
		this.setState({
			generatorIsActive : true
		});
	}
	//_______
	play(){
		this.setState({
			isPlaying : true
		});
	}
	pause(){
		this.setState({
			isPlaying : false
		});
	}

	showMobileTrigger(){
		this.setState({
			isPlaying : false,
			showMobileTrigger : true
		});
	}

	hideMobileTrigger(){
		this.setState({
			isPlaying : true,
			wasMobileTriggered : true,
			showMobileTrigger : false
		});
	}

	isWaiting(){
		this.setState({
			isWaiting : true
		})
	}

	isNotWaiting(){
		this.setState({
			isWaiting : false
		});
	}


	timeupdate(video){
		this.isNotWaiting();
		this.setState({
			currentInnerChapterTime : video.currentTime,
			currentVideoTimePercentage : (video.currentTime * 100 / video.duration).toFixed(0),
			showSongIntro:(video.currentTime < 5)
		});
	}

	ended(){
		if(this.state.showPlaylistIntro){
			this.setState({
				showPlaylistIntro : false,
				isPlaying : !_assets.isMobile,
				showMobileTrigger : _assets.isMobile,
				currentInnerChapter : 2,
				currentVideoTimePercentage : 0,
				currentInnerChapterTime : 0,
				isWaiting : true
			});
		}else{

			if(this.state.currentSong +1 == playlist_songs.length){
			
				browserHistory.push(_assets.root + '/outro');

			}	else if(playlist_songs[this.state.currentSong + 1].active){
			
				this.setState({
					isPlaying : !_assets.isMobile,
					showMobileTrigger : _assets.isMobile,
					currentSong : this.state.currentSong + 1,
					currentVideoTimePercentage : 0,
					currentInnerChapterTime : 0,
					isWaiting : true
				});
			
			}else{
			
				this.setState({
					showSongTeaser : true,
					isPlaying : false,
				});
			
			}
		}
	}

	//_______

	goToInnerChapter(num){
		
	}

	goToInnerChapterByNumber(number){

		this.setState({
			currentInnerChapter : number,
			isPlaying : true
		},()=>{
			if(number == 1){
				if(_assets.isIOS){
					this.play();
				}
			}
			if(number ==2 ){
				this.setState({
					showPlaylistIntro : false,
				});
			}
		});
	}

	render(){

		var pause_menu_bool = (!this.state.isPlaying && !this.state.songNaviOpen && !this.state.showSongTeaser && !this.state.showMobileTrigger);

		return (
			<div className="chapterContent chapter-3">
			{/* Loading Icon */}
			

			<ReactCSSTransitionGroup
				component= "div"
				className="absolute chapterContent-inner"
				transitionName="fade"
				transitionEnterTimeout={500}
				transitionLeaveTimeout={300}>

					{this.state.isWaiting &&
						<div className="is-waiting">
							<div className="is-waiting-loading-icon">
								<Iconset.videoLoadingIcon />
							</div>
						</div>
					}

					{this.state.currentInnerChapter==0 &&
						<ArtworkGenerator 
							key="generator"
							generatorIsActive = {()=>this.generatorIsActive()}
							goToInnerChapterByNumber ={(number)=>this.goToInnerChapterByNumber(number)}/>
					}
					{this.state.currentInnerChapter!=0 &&
						<Playlist 
							key="playlist-holder"
							songs={playlist_songs}
							currentInnerChapter ={this.state.currentInnerChapter}
							currentSong = {this.state.currentSong}
							songNaviOpen = {this.state.songNaviOpen}
							changeSongToIndex ={(index)=>this.changeSongToIndex(index)}
							toggleNavi ={(bool)=>this.toggleNavi(bool)}
							showPlaylistIntro={this.state.showPlaylistIntro}
							showSongIntro={this.state.showSongIntro}
							showSongTeaser={this.state.showSongTeaser}
							isPlaying={this.state.isPlaying}
							play={()=>this.play()}
							pause={()=>this.pause()}
							showMobileTriggerAction = {()=>this.showMobileTrigger()}
							showMobileTrigger = {this.state.showMobileTrigger}
							wasMobileTriggered = {this.state.wasMobileTriggered}
							setOtherTrigger = {()=>this.setOtherTrigger()}
							otherTrigger ={this.state.otherTrigger}
							hideMobileTrigger ={()=>this.hideMobileTrigger()}
							isWaiting={()=>this.isWaiting()}
							isNotWaiting={()=>this.isNotWaiting()}
							timeupdate={(video)=>this.timeupdate(video)}
							currentVideoTimePercentage = {this.state.currentVideoTimePercentage}
							ended = {()=>this.ended()}/>
					}
				</ReactCSSTransitionGroup>


				<ReactCSSTransitionGroup
						component= "div"
						className={"pause-menu-overlay-holder isPlaying-" + this.state.isPlaying + " active-chapter-" + this.state.currentInnerChapter + " song-navi-open-"+this.state.songNaviOpen + " show-mobile-trigger-" + this.state.showMobileTrigger}
			      transitionName="fadeDown"
			      transitionAppear={true}
     				transitionAppearTimeout={500}
			      transitionEnterTimeout={500}
			      transitionLeaveTimeout={300}>
			      	{ pause_menu_bool &&
			      		<Pause_menu play={()=>this.play()}
			      		chapter={3}/>
        			}			          
        	</ReactCSSTransitionGroup>

				<nav className="main-nav">
					<div className="main-nav-inner">			
							<Timeline 
								isPlaying={this.state.isPlaying}
								play={()=>this.play()}
								isPlaying={this.state.isPlaying}
								pause={()=>this.pause()}
								generatorIsActive = {this.state.generatorIsActive}
								currentInnerChapter ={this.state.currentInnerChapter}
								currentVideoTimePercentage = {this.state.currentVideoTimePercentage}
								currentInnerChapterTime = {this.state.currentInnerChapterTime}

								goToInnerChapter={(number)=>this.goToInnerChapterByNumber(number)} />
								<Shareelement chapter={this.props.chapter}/>
						
					</div>
				</nav>
			</div>
		)
	}					
}


export default Chapter_three;


// WEBPACK FOOTER //
// ./src/scripts/chapter_three.js